import { render, staticRenderFns } from "./DragUpload.vue?vue&type=template&id=418725a8&"
import script from "./DragUpload.vue?vue&type=script&lang=js&"
export * from "./DragUpload.vue?vue&type=script&lang=js&"
import style0 from "./DragUpload.vue?vue&type=style&index=0&id=418725a8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports